import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../style.css'
import { platMap, platformList } from './enmu';
import { doAddReportBrandV, doChangeReportBrandV, getReportBrandV } from '../../../../controller';

class OfficialAccount extends React.PureComponent {
  state = {
    officialAccount: [],
    accountPlatform: 'wx',
    newAccountPane: false,
    accountObject: {
      id: null,
      name: '',
      key: '',
      url: '',
      platform: 'wx'
    }
  }
  /**
   * 获取官方账号
   *
   * @memberof Brand
   */
  getReportBrandV = () => {
    const { accountPlatform } = this.state;
    const { brandName } = this.props;
    if (!brandName) return alert('请输入品牌')

    getReportBrandV({
      brandName,
      platform: accountPlatform,
    })
      .then(res => {
        if (res) {
          this.setState({
            officialAccount: res
          })
        }
      })
  }


  addAccount = () => {
    this.setState({
      newAccountPane: true,
      accountObject: {
        id: null,
        name: '',
        key: '',
        platform: 'wx'
      }
    })
  }

  /**
   * 打开编辑面板
   *
   * @memberof Brand
   */
  editAccount = (item) => {
    this.setState({
      newAccountPane: true,
      accountObject: {
        id: item.id,
        name: item.vName,
        key: item.key,
        url: item.url,
        platform: item.platform
      }
    })
  }

  /**
   * 关闭新增窗口
   *
   * @memberof Brand
   */
  cancelAccount = () => {
    this.setState({
      newAccountPane: false,
      accountObject: {
        id: null,
        name: '',
        key: '',
        url: '',
        platform: 'wx'
      }
    })
  }

  /**
   * 新增官方账号
   * @memberof Brand
   */
  addAccountAction = (query) => {
    doAddReportBrandV(query)
      .then(res => {
        if(res.errCode==1){
          alert('操作失败！')
        }else{
          alert('操作成功！')
          this.getReportBrandV()
        }
        this.cancelAccount()
      })
  }


  /**
   * 修改官方账号
   * @memberof Brand
   */
  editAccountAction = (query) => {
    doChangeReportBrandV(query)
      .then(res => {
        if(res && res.errCode==1){
          alert('操作失败！')
        }else{
          alert('操作成功！')
          this.getReportBrandV()
        }
        this.cancelAccount()
      })
  }

  /**
   * 提交修改|新增账号
   * @memberof Brand
   */
  submitAccount = () => {
    const {accountObject} = this.state
    const { brandName } = this.props;

    const query = {
      brandName,
      platform: accountObject.platform,
      vName: accountObject.name,
      key: accountObject.key
    }
    if (accountObject.platform === 'wx') {
      query.url = accountObject.url
    }

    if (accountObject.id) {
      query.id = accountObject.id
      this.editAccountAction(query)
    } else {
      this.addAccountAction(query)
    }
  }

  /**
   * 新增|修改账号属性
   * @memberof Brand
   */
  accountChange = (name, value) => {
    const accountObject = this.state.accountObject
    this.setState({
      accountObject: {
        ...accountObject,
        [name]: value
      }
    })
  }

  render() {
    const { officialAccount, accountPlatform, newAccountPane, accountObject } = this.state;
    const { brandName } = this.props;

    return (
      <div className={s.wrapper} style={{ background: '#fff', border: '1px solid #ebedf0', borderRadius: 0 }}>
        <div style={{ display: 'flex' }}>

          <div className={s.item}>
            <label className={s.label}>查询品牌：</label>
            {brandName}
          </div>
          <div className={s.item}>
            <label className={s.label}>选择平台：</label>
            <select className={s.input} value={accountPlatform} onChange={(e) => this.setState({ accountPlatform: e.target.value })}>
              {platformList.map(item => <option value={item.type} key={item.type}>{item.class}</option>)}
              <option value="wk">悟空问答</option>
            </select>
          </div>

          <hr />

          <div className={s.btnWrapper}>
            <button className={s.btn} type="button" onClick={this.getReportBrandV}>查询</button>
            <button className={s.btn} type="button" onClick={this.addAccount}>新建</button>
          </div>
        </div>
        <div className={s.tableWrapper}>
          <table className={s.table}>
            <thead>
              <tr>
                <th>id</th>
                <th>官网名称</th>
                <th>key</th>
                <th>平台</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              {officialAccount.length === 0 && <tr><td colSpan={5}>暂无数据</td></tr>}
              {officialAccount.map((item, index) => (
                <tr key={index}>
                  <td>{item.vName}</td>
                  <td>{item.vName}</td>
                  <td>{item.key}</td>
                  <td>{platMap[item.platform]}</td>
                  <td>
                    <span style={{ cursor: 'pointer' }} onClick={() => this.editAccount(item)}>修改</span>
                    /
                    <span onClick={() => { this.delAccountAction(item) }} style={{ cursor: 'pointer', color: 'red' }}>删除</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>


          {newAccountPane &&
            <div className={s.newAccount}>
              {accountObject.id &&
                <div className={s.item}>
                  <label className={s.label}>官网名称：</label>
                  {accountObject.id}
                </div>
              }

              <div className={s.item}>
                <label className={s.label}>选择平台：</label>
                <select className={s.input} value={accountObject.platform} onChange={e => this.accountChange('platform', e.target.value)}>
                  {platformList.map(item => <option value={item.type} key={item.type}>{item.class}</option>)}
                </select>
              </div>

              <div className={s.item}>
                <label className={s.label}>官网名称：</label>
                <input className={s.input} value={accountObject.name} onChange={e => this.accountChange('name', e.target.value)} />
              </div>

              <div className={s.item}>
                <label className={s.label}>key：</label>
                <input className={s.input} value={accountObject.key} onChange={e => this.accountChange('key', e.target.value)} />
              </div>

              {accountObject.platform === 'wx' &&
                <div className={s.item}>
                  <label className={s.label}>文章链接：</label>
                  <input className={s.input} value={accountObject.url} onChange={e => this.accountChange('url', e.target.value)} />
                </div>
              }

              <div className={s.btnWrapper}>
                <button className={s.btn} type="button" onClick={this.submitAccount}>提交</button>
                <button className={s.btn} type="button" onClick={this.cancelAccount}>取消</button>
              </div>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default withStyles(s)(OfficialAccount)



// WEBPACK FOOTER //
// src/routes/cms/components/BrandComponent/OfficialAccount.js